import { clsx } from 'clsx'
import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { productSearchAlgoliaAccessorIsRxCh } from '../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorIsRxCh'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'
import { useResultItemStockStatus } from './useResultItemStockStatus'

export const ProductSearchResultItemStockStatus: FC = () => {
  const resultItemStockStatus = useResultItemStockStatus()
  const { tenant } = useGlobalConfigContext()
  const { algoliaRecord } = useProductSearchResultItemContext()

  // For Rx products on CH we don't show stock status as we don't sell them directly but through MediService
  const isRxChProduct = productSearchAlgoliaAccessorIsRxCh({
    algoliaRecord,
    tenant,
  })

  if (isRxChProduct) {
    return null
  }

  return (
    <div className="flex items-center gap-2">
      <span
        className={clsx(
          'inline-block size-2 rounded-full',
          resultItemStockStatus.dotColor,
        )}
      />
      <span
        className={clsx('font-medium', resultItemStockStatus.color)}
        data-qa-id="product-status-qa-id"
      >
        {resultItemStockStatus.message}
      </span>
    </div>
  )
}
